var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTypesofadmission(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16237 12.421C9.05298 12.5303 8.90463 12.5918 8.74995 12.5918C8.59527 12.5918 8.44693 12.5303 8.33754 12.421L7.41237 11.4958C7.30301 11.3864 7.24158 11.2381 7.24158 11.0834C7.24158 10.9287 7.30301 10.7804 7.41237 10.671L10.6709 7.41249C10.7803 7.30313 10.9286 7.2417 11.0833 7.2417C11.238 7.2417 11.3863 7.30313 11.4957 7.41249L12.4209 8.33766C12.5302 8.44705 12.5917 8.5954 12.5917 8.75007C12.5917 8.90475 12.5302 9.0531 12.4209 9.16249L9.16237 12.421Z",
    stroke: "#1D4ED8",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7.58317L9.69788 3.57334C9.67606 3.46425 9.6235 3.36366 9.5464 3.28346C9.4693 3.20326 9.37086 3.14677 9.26271 3.12067L1.88705 1.18284C1.78988 1.15935 1.6883 1.16122 1.59207 1.18828C1.49583 1.21534 1.40817 1.26667 1.33748 1.33736C1.26679 1.40805 1.21546 1.49571 1.1884 1.59195C1.16134 1.68818 1.15947 1.78976 1.18296 1.88692L3.1208 9.26259C3.14689 9.37074 3.20338 9.46917 3.28358 9.54628C3.36379 9.62338 3.46437 9.67594 3.57346 9.69776L7.5833 10.4998",
    stroke: "#1D4ED8",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.34167 1.3418L5.59184 5.59196",
    stroke: "#1D4ED8",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41667 7.58333C7.061 7.58333 7.58333 7.061 7.58333 6.41667C7.58333 5.77233 7.061 5.25 6.41667 5.25C5.77233 5.25 5.25 5.77233 5.25 6.41667C5.25 7.061 5.77233 7.58333 6.41667 7.58333Z",
    stroke: "#1D4ED8",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypesofadmission);
export default __webpack_public_path__ + "static/media/typesofadmission.8641c02cc816a7a61335b9bac2dc48a9.svg";
export { ForwardRef as ReactComponent };